/* eslint-disable */
export const baseUrl = "http://107.149.104.7/Service";  // 开发: http://192.168.1.248:8020 线上：  http://107.149.104.7/Service

// url2
export const url_CM = 'http://107.149.104.7'; // 开发：http://47.56.195.204, 线上： ''

// url LN
export const url_LN = 'http://107.149.104.7:9999';  // 线上：107.149.104.7, 开发：192.168.1.59:9999

// url unilateral local
export const url_LN_local = 'http://107.149.104.7:8025'; // http://192.168.1.221:8025 // http://107.149.104.7:8025

// 临时策略 url
export const url_temp = "http://107.149.104.7:8026";  // http://192.168.1.221 // http://107.149.104.7

// 任务请求等待时间
export const taskWaitTimer = 8;

// 单边 url
export  const socket_url_ln = "ws://107.149.104.7:8025"; // ws://107.149.104.7:8025 , // ws://192.168.1.221:8025

export const LOCAL_URL = 'http://192.168.1.221:8025';

// 曹觅矿机
export const URL_KJ = "http://107.149.104.7/ts1";

//本地
export const URL_LN2 = 'http://107.149.104.7:8026'